var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-meta" }, [
    _c("ul", { staticClass: "nav-meta__list" }, [
      _c(
        "li",
        {
          staticClass:
            "nav-meta__list-item nav-meta__list-item--login login-widget",
          class: {
            "nav-meta__list-item--hide": !_vm.showLogin
          }
        },
        [_c("WidgetLogin")],
        1
      ),
      _vm._v(" "),
      _vm.showReservation
        ? _c(
            "li",
            {
              staticClass:
                "nav-meta__list-item nav-meta__list-item--reservation reservation-widget"
            },
            [_c("WidgetReservation")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCart
        ? _c(
            "li",
            {
              staticClass:
                "nav-meta__list-item nav-meta__list-item--cart cart-widget"
            },
            [_c("WidgetCart")],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }